import React, {useEffect, useState} from "react";
import {Button, TextField} from "@mui/material";

/*
    DisplayManualForm is used in LandingAutoComplete.js
    @param {function} selectPlace - function to select a place
    @param {boolean} showManualForm - show or hide the manual form
    @param {function} setShowManualForm - function to show or hide the manual form
 */
export default function DisplayManualForm({selectPlace,showManualForm,setShowManualForm}) {

    const [city,setCity] = useState('');
    const [street,setStreet] = useState('');
    const [nr,setNr] = useState('');
    const [suburb,setSuburb] = useState('');
    const [postCode,setPostCode] = useState('');
    const [pcError,setPCError] = useState(false);
    const [valid,setValid] = useState(false);

    useEffect(() => {
        let x = false;
        x = ((postCode.length < 3 || postCode.length > 4) === true || postCode.match(/^[0-9]+$/) === null);
        setPCError(x);

        setValid (
            !((postCode.length < 3 || postCode.length > 4) === true || postCode.match(/^[0-9]+$/) === null) &&
            nr.length > 0 &&
            street.length > 0 &&
            city.length > 0 &&
            suburb.length > 0
        )

    }, [nr,street,suburb,city,postCode]);


    function submitAddress(e) {
        let res = ({
            "address": nr.toUpperCase() + " " + street.toUpperCase() + ", " + suburb.toUpperCase() + "," + city.toUpperCase() + "," + postCode,
            "SUBURB_NAME": suburb.toUpperCase(),
            "TOWN_CITY_MAILTOWN": city.toUpperCase(),
            "POSTCODE":postCode,
            "STREET_NAME": street.toUpperCase(),
            "STREET_NUMBER": nr.toUpperCase(),
            "cast(a.X_COORDINATE as float)": null,
            "Y_COORDINATE": null,
            "DPID": null,
            "address_optimised": ""
        });

        selectPlace(e,res)

    }

    if(showManualForm === false) return null;
    return (
        <div>
            <TextField error={(nr.length === 0)}
                       value={nr} id="outlined-basic" label={"Street number"}
                       variant="outlined" sx={{width:'100%',marginBottom:2}}
                       onChange={(e) => {
                           setNr(e.target.value)
                       }}
            />
            <TextField error={(street.length === 0)}
                       value={street} id="outlined-basic" label={" Street"}
                       variant="outlined" sx={{width:'100%',marginBottom:2}}
                       onChange={(e) => {
                           setStreet(e.target.value)
                       }}
            />

            <TextField error={(suburb.length === 0)}
                       value={suburb} id="outlined-basic" label={"Suburb"}
                       variant="outlined" sx={{width:'100%',marginBottom:2}}
                       onChange={(e) => {
                           setSuburb(e.target.value)
                       }}
            />

            <TextField error={(city.length === 0)}
                       value={city} id="outlined-basic" label={"City"}
                       variant="outlined" sx={{width:'100%',marginBottom:2}}
                       onChange={(e) => {
                           setCity(e.target.value)
                       }}
            />

            <TextField error={pcError}
                       value={postCode} id="outlined-basic" label={"Postcode"}
                       variant="outlined" sx={{width:'100%',marginBottom:2}}
                       onChange={(e) => {
                           setPostCode(e.target.value)
                       }}
            />

            <Button disabled={!valid}
                    sx={{width:'auto'}}
                    variant={"contained"}
                    onClick={submitAddress}>Use address</Button>
            <Button sx={{width:'auto'}} onClick={() => setShowManualForm(false)}>Cancel</Button>

        </div>
    )

}
